import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Created by commyfeng on 2017/3/21.
 */
import Request from "./Request";
import ZeptoJSONP from "../middleware/ZeptoJSONP";
var _defaultRequester = ZeptoJSONP();
var Coa = /*#__PURE__*/function () {
  function Coa(fn) {
    _classCallCheck(this, Coa);
    if (!(this instanceof Coa)) return new Coa(fn);
    this.middleware = [];
    this.use.apply(this, arguments);
  }
  _createClass(Coa, [{
    key: "use",
    value: function use(fn) {
      var fns = Array.prototype.slice.call(arguments);
      if (typeof fn !== 'undefined' && fn instanceof Array) {
        fns = fn;
      }
      var _iterator = _createForOfIteratorHelper(fns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          fn = _step.value;
          if (typeof fn !== 'function') throw new TypeError('中间件必须是async 函数哦');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.middleware = this.middleware.concat(fns);
      this.buildRunner();
      return this;
    }
  }, {
    key: "buildRunner",
    value: function buildRunner() {
      return this.runner = this.middleware.reduceRight(function (next, fn) {
        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fn.apply(this, [next.bind(this)]);
                case 2:
                  return _context.abrupt("return", _context.sent);
                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      }, _defaultRequester);
    }
  }, {
    key: "compose",
    value: function compose(coa) {
      if (!(coa instanceof Coa)) throw new TypeError('必须为Coa对象才能互相连接');
      this.use(coa.middleware);
      return this;
    }

    // async _default () {
    //     throw new Error('请求没有被发送出去，请使用中间件发送请求')
    // }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data, options) {
        var context;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = {
                  request: new Request(url, data, options),
                  response: null
                };
                _context2.next = 3;
                return this.runner.apply(context);
              case 3:
                return _context2.abrupt("return", context.response);
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function run(_x, _x2, _x3) {
        return _run.apply(this, arguments);
      }
      return run;
    }()
  }], [{
    key: "setDefaultRequester",
    value: function setDefaultRequester(fn) {
      _defaultRequester = fn;
    }
  }]);
  return Coa;
}();
export default Coa;